// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--v9+KD";
export var legalLinks = "Footer-module--legalLinks--wmZqE";
export var socialMedia = "Footer-module--socialMedia--B2rwd";